import { PRODUCT_CLASSIFICATION_CODE as N } from "@smart/types";
import "./index-xuotMAFm.mjs";
import { c as J, a as tt } from "./helpers-BfS4Sl3r.mjs";
import { D as E, E as D, a as W, T as C, C as K, b as et, P as Y, f as P, s as it, c as st, i as B, d as U, e as X, g as nt, h as at, j as _, k as rt, l as F, m as ot, n as ht, o as lt, x as ct, p as ut, q as O, r as z, t as dt, u as ft } from "./index-C-My4wxZ.mjs";
function Pt(e, t, i) {
  const { showAccelerationAndTopSpeed: s } = e;
  if (s)
    return t;
  {
    const a = (h) => i.some((l) => h.toLowerCase().includes(l));
    return t == null ? void 0 : t.filter(
      (h) => !a(h == null ? void 0 : h.code)
    );
  }
}
const G = {
  withStartIndices: !1,
  withEndIndices: !1,
  xmlMode: !1
};
class mt {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(t, i, s) {
    this.dom = [], this.root = new E(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof i == "function" && (s = i, i = G), typeof t == "object" && (i = t, t = void 0), this.callback = t ?? null, this.options = i ?? G, this.elementCB = s ?? null;
  }
  onparserinit(t) {
    this.parser = t;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [], this.root = new E(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
  }
  onerror(t) {
    this.handleCallback(t);
  }
  onclosetag() {
    this.lastNode = null;
    const t = this.tagStack.pop();
    this.options.withEndIndices && (t.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(t);
  }
  onopentag(t, i) {
    const s = this.options.xmlMode ? D.Tag : void 0, a = new W(t, i, void 0, s);
    this.addNode(a), this.tagStack.push(a);
  }
  ontext(t) {
    const { lastNode: i } = this;
    if (i && i.type === D.Text)
      i.data += t, this.options.withEndIndices && (i.endIndex = this.parser.endIndex);
    else {
      const s = new C(t);
      this.addNode(s), this.lastNode = s;
    }
  }
  oncomment(t) {
    if (this.lastNode && this.lastNode.type === D.Comment) {
      this.lastNode.data += t;
      return;
    }
    const i = new K(t);
    this.addNode(i), this.lastNode = i;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const t = new C(""), i = new et([t]);
    this.addNode(i), t.parent = i, this.lastNode = t;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(t, i) {
    const s = new Y(t, i);
    this.addNode(s);
  }
  handleCallback(t) {
    if (typeof this.callback == "function")
      this.callback(t, this.dom);
    else if (t)
      throw t;
  }
  addNode(t) {
    const i = this.tagStack[this.tagStack.length - 1], s = i.children[i.children.length - 1];
    this.options.withStartIndices && (t.startIndex = this.parser.startIndex), this.options.withEndIndices && (t.endIndex = this.parser.endIndex), i.children.push(t), s && (t.prev = s, s.next = t), t.parent = i, this.lastNode = null;
  }
}
function bt(e, t) {
  return function i(s, a, r = !0) {
    if (s == null)
      throw new Error("cheerio.load() expects a string");
    const h = P(a), l = e(s, h, r, null);
    class u extends st {
      _make(c, m) {
        const x = g(c, m);
        return x.prevObject = this, x;
      }
      _parse(c, m, x, p) {
        return e(c, m, x, p);
      }
      _render(c) {
        return t(c, this.options);
      }
    }
    function g(f, c, m = l, x) {
      if (f && B(f))
        return f;
      const p = P(x, h), k = typeof m == "string" ? [e(m, p, !1, null)] : "length" in m ? m : [m], T = B(k) ? k : new u(k, null, p);
      if (T._root = T, !f)
        return new u(void 0, T, p);
      const L = typeof f == "string" && U(f) ? (
        // $(<html>)
        e(f, p, !1, null).children
      ) : gt(f) ? (
        // $(dom)
        [f]
      ) : Array.isArray(f) ? (
        // $([dom])
        f
      ) : void 0, V = new u(L, T, p);
      if (L)
        return V;
      if (typeof f != "string")
        throw new TypeError("Unexpected type of selector");
      let y = f;
      const M = c ? (
        // If we don't have a context, maybe we have a root, from loading
        typeof c == "string" ? U(c) ? (
          // $('li', '<ul>...</ul>')
          new u([e(c, p, !1, null)], T, p)
        ) : (
          // $('li', 'ul')
          (y = `${c} ${y}`, T)
        ) : B(c) ? (
          // $('li', $)
          c
        ) : (
          // $('li', node), $('li', [nodes])
          new u(Array.isArray(c) ? c : [c], T, p)
        )
      ) : T;
      return M ? M.find(y) : V;
    }
    return Object.assign(g, it, {
      load: i,
      // `_root` and `_options` are used in static methods.
      _root: l,
      _options: h,
      // Add `fn` for plugins
      fn: u.prototype,
      // Add the prototype here to maintain `instanceof` behavior.
      prototype: u.prototype
    }), g;
  };
}
function gt(e) {
  return !!e.name || e.type === "root" || e.type === "text" || e.type === "comment";
}
function pt(e, t) {
  return X.parse(e, t);
}
function xt(e, t, i) {
  typeof e == "string" && (i = t, t = e, e = null);
  const s = X.getFragmentParser(e, i);
  return s.tokenizer.write(t, !0), s.getFragment();
}
function Q(e) {
  const t = e.includes('"') ? "'" : '"';
  return t + e + t;
}
function St(e, t, i) {
  let s = "!DOCTYPE ";
  return e && (s += e), t ? s += ` PUBLIC ${Q(t)}` : i && (s += " SYSTEM"), i && (s += ` ${Q(i)}`), s;
}
const A = {
  // Re-exports from domhandler
  isCommentNode: nt,
  isElementNode: at,
  isTextNode: _,
  //Node construction
  createDocument() {
    const e = new E([]);
    return e["x-mode"] = rt.NO_QUIRKS, e;
  },
  createDocumentFragment() {
    return new E([]);
  },
  createElement(e, t, i) {
    const s = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
    for (let l = 0; l < i.length; l++) {
      const u = i[l].name;
      s[u] = i[l].value, a[u] = i[l].namespace, r[u] = i[l].prefix;
    }
    const h = new W(e, s, []);
    return h.namespace = t, h["x-attribsNamespace"] = a, h["x-attribsPrefix"] = r, h;
  },
  createCommentNode(e) {
    return new K(e);
  },
  createTextNode(e) {
    return new C(e);
  },
  //Tree mutation
  appendChild(e, t) {
    const i = e.children[e.children.length - 1];
    i && (i.next = t, t.prev = i), e.children.push(t), t.parent = e;
  },
  insertBefore(e, t, i) {
    const s = e.children.indexOf(i), { prev: a } = i;
    a && (a.next = t, t.prev = a), i.prev = t, t.next = i, e.children.splice(s, 0, t), t.parent = e;
  },
  setTemplateContent(e, t) {
    A.appendChild(e, t);
  },
  getTemplateContent(e) {
    return e.children[0];
  },
  setDocumentType(e, t, i, s) {
    const a = St(t, i, s);
    let r = e.children.find((h) => F(h) && h.name === "!doctype");
    r ? r.data = a ?? null : (r = new Y("!doctype", a), A.appendChild(e, r)), r["x-name"] = t, r["x-publicId"] = i, r["x-systemId"] = s;
  },
  setDocumentMode(e, t) {
    e["x-mode"] = t;
  },
  getDocumentMode(e) {
    return e["x-mode"];
  },
  detachNode(e) {
    if (e.parent) {
      const t = e.parent.children.indexOf(e), { prev: i, next: s } = e;
      e.prev = null, e.next = null, i && (i.next = s), s && (s.prev = i), e.parent.children.splice(t, 1), e.parent = null;
    }
  },
  insertText(e, t) {
    const i = e.children[e.children.length - 1];
    i && _(i) ? i.data += t : A.appendChild(e, A.createTextNode(t));
  },
  insertTextBefore(e, t, i) {
    const s = e.children[e.children.indexOf(i) - 1];
    s && _(s) ? s.data += t : A.insertBefore(e, A.createTextNode(t), i);
  },
  adoptAttributes(e, t) {
    for (let i = 0; i < t.length; i++) {
      const s = t[i].name;
      e.attribs[s] === void 0 && (e.attribs[s] = t[i].value, e["x-attribsNamespace"][s] = t[i].namespace, e["x-attribsPrefix"][s] = t[i].prefix);
    }
  },
  //Tree traversing
  getFirstChild(e) {
    return e.children[0];
  },
  getChildNodes(e) {
    return e.children;
  },
  getParentNode(e) {
    return e.parent;
  },
  getAttrList(e) {
    return e.attributes;
  },
  //Node data
  getTagName(e) {
    return e.name;
  },
  getNamespaceURI(e) {
    return e.namespace;
  },
  getTextNodeContent(e) {
    return e.data;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    var t;
    return (t = e["x-name"]) !== null && t !== void 0 ? t : "";
  },
  getDocumentTypeNodePublicId(e) {
    var t;
    return (t = e["x-publicId"]) !== null && t !== void 0 ? t : "";
  },
  getDocumentTypeNodeSystemId(e) {
    var t;
    return (t = e["x-systemId"]) !== null && t !== void 0 ? t : "";
  },
  //Node types
  isDocumentTypeNode(e) {
    return F(e) && e.name === "!doctype";
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    t && (e.startIndex = t.startOffset, e.endIndex = t.endOffset), e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    t.endOffset != null && (e.endIndex = t.endOffset), e.sourceCodeLocation = {
      ...e.sourceCodeLocation,
      ...t
    };
  }
};
function It(e, t, i, s) {
  var a;
  return (a = t.treeAdapter) !== null && a !== void 0 || (t.treeAdapter = A), t.scriptingEnabled !== !1 && (t.scriptingEnabled = !0), i ? pt(e, t) : xt(s, e, t);
}
const Tt = { treeAdapter: A };
function At(e) {
  const t = "length" in e ? e : [e];
  for (let s = 0; s < t.length; s += 1) {
    const a = t[s];
    ot(a) && Array.prototype.splice.call(t, s, 1, ...a.children);
  }
  let i = "";
  for (let s = 0; s < t.length; s += 1) {
    const a = t[s];
    i += ht(a, Tt);
  }
  return i;
}
var o;
(function(e) {
  e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(o || (o = {}));
var n;
(function(e) {
  e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.InSpecialComment = 20] = "InSpecialComment", e[e.InCommentLike = 21] = "InCommentLike", e[e.BeforeSpecialS = 22] = "BeforeSpecialS", e[e.BeforeSpecialT = 23] = "BeforeSpecialT", e[e.SpecialStartSequence = 24] = "SpecialStartSequence", e[e.InSpecialTag = 25] = "InSpecialTag", e[e.InEntity = 26] = "InEntity";
})(n || (n = {}));
function I(e) {
  return e === o.Space || e === o.NewLine || e === o.Tab || e === o.FormFeed || e === o.CarriageReturn;
}
function q(e) {
  return e === o.Slash || e === o.Gt || I(e);
}
function Nt(e) {
  return e >= o.LowerA && e <= o.LowerZ || e >= o.UpperA && e <= o.UpperZ;
}
var S;
(function(e) {
  e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
})(S || (S = {}));
const b = {
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  // CDATA[
  CdataEnd: new Uint8Array([93, 93, 62]),
  // ]]>
  CommentEnd: new Uint8Array([45, 45, 62]),
  // `-->`
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  // `<\/script`
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  // `</style`
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
  // `</title`
  TextareaEnd: new Uint8Array([
    60,
    47,
    116,
    101,
    120,
    116,
    97,
    114,
    101,
    97
  ])
  // `</textarea`
};
class vt {
  constructor({ xmlMode: t = !1, decodeEntities: i = !0 }, s) {
    this.cbs = s, this.state = n.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.entityStart = 0, this.baseState = n.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.xmlMode = t, this.decodeEntities = i, this.entityDecoder = new lt(t ? ct : ut, (a, r) => this.emitCodePoint(a, r));
  }
  reset() {
    this.state = n.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = n.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
  }
  write(t) {
    this.offset += this.buffer.length, this.buffer = t, this.parse();
  }
  end() {
    this.running && this.finish();
  }
  pause() {
    this.running = !1;
  }
  resume() {
    this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
  }
  stateText(t) {
    t === o.Lt || !this.decodeEntities && this.fastForwardTo(o.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = n.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === o.Amp && this.startEntity();
  }
  stateSpecialStartSequence(t) {
    const i = this.sequenceIndex === this.currentSequence.length;
    if (!(i ? (
      // If we are at the end of the sequence, make sure the tag name has ended
      q(t)
    ) : (
      // Otherwise, do a case-insensitive comparison
      (t | 32) === this.currentSequence[this.sequenceIndex]
    )))
      this.isSpecial = !1;
    else if (!i) {
      this.sequenceIndex++;
      return;
    }
    this.sequenceIndex = 0, this.state = n.InTagName, this.stateInTagName(t);
  }
  /** Look for an end tag. For <title> tags, also decode entities. */
  stateInSpecialTag(t) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (t === o.Gt || I(t)) {
        const i = this.index - this.currentSequence.length;
        if (this.sectionStart < i) {
          const s = this.index;
          this.index = i, this.cbs.ontext(this.sectionStart, i), this.index = s;
        }
        this.isSpecial = !1, this.sectionStart = i + 2, this.stateInClosingTagName(t);
        return;
      }
      this.sequenceIndex = 0;
    }
    (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === b.TitleEnd ? this.decodeEntities && t === o.Amp && this.startEntity() : this.fastForwardTo(o.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === o.Lt);
  }
  stateCDATASequence(t) {
    t === b.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === b.Cdata.length && (this.state = n.InCommentLike, this.currentSequence = b.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = n.InDeclaration, this.stateInDeclaration(t));
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */
  fastForwardTo(t) {
    for (; ++this.index < this.buffer.length + this.offset; )
      if (this.buffer.charCodeAt(this.index - this.offset) === t)
        return !0;
    return this.index = this.buffer.length + this.offset - 1, !1;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */
  stateInCommentLike(t) {
    t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === b.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = n.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   */
  isTagStartChar(t) {
    return this.xmlMode ? !q(t) : Nt(t);
  }
  startSpecial(t, i) {
    this.isSpecial = !0, this.currentSequence = t, this.sequenceIndex = i, this.state = n.SpecialStartSequence;
  }
  stateBeforeTagName(t) {
    if (t === o.ExclamationMark)
      this.state = n.BeforeDeclaration, this.sectionStart = this.index + 1;
    else if (t === o.Questionmark)
      this.state = n.InProcessingInstruction, this.sectionStart = this.index + 1;
    else if (this.isTagStartChar(t)) {
      const i = t | 32;
      this.sectionStart = this.index, this.xmlMode ? this.state = n.InTagName : i === b.ScriptEnd[2] ? this.state = n.BeforeSpecialS : i === b.TitleEnd[2] ? this.state = n.BeforeSpecialT : this.state = n.InTagName;
    } else t === o.Slash ? this.state = n.BeforeClosingTagName : (this.state = n.Text, this.stateText(t));
  }
  stateInTagName(t) {
    q(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateBeforeClosingTagName(t) {
    I(t) || (t === o.Gt ? this.state = n.Text : (this.state = this.isTagStartChar(t) ? n.InClosingTagName : n.InSpecialComment, this.sectionStart = this.index));
  }
  stateInClosingTagName(t) {
    (t === o.Gt || I(t)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = n.AfterClosingTagName, this.stateAfterClosingTagName(t));
  }
  stateAfterClosingTagName(t) {
    (t === o.Gt || this.fastForwardTo(o.Gt)) && (this.state = n.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeAttributeName(t) {
    t === o.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = n.InSpecialTag, this.sequenceIndex = 0) : this.state = n.Text, this.sectionStart = this.index + 1) : t === o.Slash ? this.state = n.InSelfClosingTag : I(t) || (this.state = n.InAttributeName, this.sectionStart = this.index);
  }
  stateInSelfClosingTag(t) {
    t === o.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = n.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : I(t) || (this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateInAttributeName(t) {
    (t === o.Eq || q(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = n.AfterAttributeName, this.stateAfterAttributeName(t));
  }
  stateAfterAttributeName(t) {
    t === o.Eq ? this.state = n.BeforeAttributeValue : t === o.Slash || t === o.Gt ? (this.cbs.onattribend(S.NoValue, this.sectionStart), this.sectionStart = -1, this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(t)) : I(t) || (this.cbs.onattribend(S.NoValue, this.sectionStart), this.state = n.InAttributeName, this.sectionStart = this.index);
  }
  stateBeforeAttributeValue(t) {
    t === o.DoubleQuote ? (this.state = n.InAttributeValueDq, this.sectionStart = this.index + 1) : t === o.SingleQuote ? (this.state = n.InAttributeValueSq, this.sectionStart = this.index + 1) : I(t) || (this.sectionStart = this.index, this.state = n.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
  }
  handleInAttributeValue(t, i) {
    t === i || !this.decodeEntities && this.fastForwardTo(i) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(i === o.DoubleQuote ? S.Double : S.Single, this.index + 1), this.state = n.BeforeAttributeName) : this.decodeEntities && t === o.Amp && this.startEntity();
  }
  stateInAttributeValueDoubleQuotes(t) {
    this.handleInAttributeValue(t, o.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(t) {
    this.handleInAttributeValue(t, o.SingleQuote);
  }
  stateInAttributeValueNoQuotes(t) {
    I(t) || t === o.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(S.Unquoted, this.index), this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === o.Amp && this.startEntity();
  }
  stateBeforeDeclaration(t) {
    t === o.OpeningSquareBracket ? (this.state = n.CDATASequence, this.sequenceIndex = 0) : this.state = t === o.Dash ? n.BeforeComment : n.InDeclaration;
  }
  stateInDeclaration(t) {
    (t === o.Gt || this.fastForwardTo(o.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = n.Text, this.sectionStart = this.index + 1);
  }
  stateInProcessingInstruction(t) {
    (t === o.Gt || this.fastForwardTo(o.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = n.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeComment(t) {
    t === o.Dash ? (this.state = n.InCommentLike, this.currentSequence = b.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = n.InDeclaration;
  }
  stateInSpecialComment(t) {
    (t === o.Gt || this.fastForwardTo(o.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = n.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeSpecialS(t) {
    const i = t | 32;
    i === b.ScriptEnd[3] ? this.startSpecial(b.ScriptEnd, 4) : i === b.StyleEnd[3] ? this.startSpecial(b.StyleEnd, 4) : (this.state = n.InTagName, this.stateInTagName(t));
  }
  stateBeforeSpecialT(t) {
    const i = t | 32;
    i === b.TitleEnd[3] ? this.startSpecial(b.TitleEnd, 4) : i === b.TextareaEnd[3] ? this.startSpecial(b.TextareaEnd, 4) : (this.state = n.InTagName, this.stateInTagName(t));
  }
  startEntity() {
    this.baseState = this.state, this.state = n.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? O.Strict : this.baseState === n.Text || this.baseState === n.InSpecialTag ? O.Legacy : O.Attribute);
  }
  stateInEntity() {
    const t = this.entityDecoder.write(this.buffer, this.index - this.offset);
    t >= 0 ? (this.state = this.baseState, t === 0 && (this.index = this.entityStart)) : this.index = this.offset + this.buffer.length - 1;
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    this.running && this.sectionStart !== this.index && (this.state === n.Text || this.state === n.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === n.InAttributeValueDq || this.state === n.InAttributeValueSq || this.state === n.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    for (; this.shouldContinue(); ) {
      const t = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case n.Text: {
          this.stateText(t);
          break;
        }
        case n.SpecialStartSequence: {
          this.stateSpecialStartSequence(t);
          break;
        }
        case n.InSpecialTag: {
          this.stateInSpecialTag(t);
          break;
        }
        case n.CDATASequence: {
          this.stateCDATASequence(t);
          break;
        }
        case n.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(t);
          break;
        }
        case n.InAttributeName: {
          this.stateInAttributeName(t);
          break;
        }
        case n.InCommentLike: {
          this.stateInCommentLike(t);
          break;
        }
        case n.InSpecialComment: {
          this.stateInSpecialComment(t);
          break;
        }
        case n.BeforeAttributeName: {
          this.stateBeforeAttributeName(t);
          break;
        }
        case n.InTagName: {
          this.stateInTagName(t);
          break;
        }
        case n.InClosingTagName: {
          this.stateInClosingTagName(t);
          break;
        }
        case n.BeforeTagName: {
          this.stateBeforeTagName(t);
          break;
        }
        case n.AfterAttributeName: {
          this.stateAfterAttributeName(t);
          break;
        }
        case n.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(t);
          break;
        }
        case n.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(t);
          break;
        }
        case n.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(t);
          break;
        }
        case n.AfterClosingTagName: {
          this.stateAfterClosingTagName(t);
          break;
        }
        case n.BeforeSpecialS: {
          this.stateBeforeSpecialS(t);
          break;
        }
        case n.BeforeSpecialT: {
          this.stateBeforeSpecialT(t);
          break;
        }
        case n.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(t);
          break;
        }
        case n.InSelfClosingTag: {
          this.stateInSelfClosingTag(t);
          break;
        }
        case n.InDeclaration: {
          this.stateInDeclaration(t);
          break;
        }
        case n.BeforeDeclaration: {
          this.stateBeforeDeclaration(t);
          break;
        }
        case n.BeforeComment: {
          this.stateBeforeComment(t);
          break;
        }
        case n.InProcessingInstruction: {
          this.stateInProcessingInstruction(t);
          break;
        }
        case n.InEntity: {
          this.stateInEntity();
          break;
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    this.state === n.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const t = this.buffer.length + this.offset;
    this.sectionStart >= t || (this.state === n.InCommentLike ? this.currentSequence === b.CdataEnd ? this.cbs.oncdata(this.sectionStart, t, 0) : this.cbs.oncomment(this.sectionStart, t, 0) : this.state === n.InTagName || this.state === n.BeforeAttributeName || this.state === n.BeforeAttributeValue || this.state === n.AfterAttributeName || this.state === n.InAttributeName || this.state === n.InAttributeValueSq || this.state === n.InAttributeValueDq || this.state === n.InAttributeValueNq || this.state === n.InClosingTagName || this.cbs.ontext(this.sectionStart, t));
  }
  emitCodePoint(t, i) {
    this.baseState !== n.Text && this.baseState !== n.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + i, this.index = this.sectionStart - 1, this.cbs.onattribentity(t)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + i, this.index = this.sectionStart - 1, this.cbs.ontextentity(t, this.sectionStart));
  }
}
const w = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), d = /* @__PURE__ */ new Set(["p"]), $ = /* @__PURE__ */ new Set(["thead", "tbody"]), R = /* @__PURE__ */ new Set(["dd", "dt"]), j = /* @__PURE__ */ new Set(["rt", "rp"]), wt = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", d],
  ["h1", d],
  ["h2", d],
  ["h3", d],
  ["h4", d],
  ["h5", d],
  ["h6", d],
  ["select", w],
  ["input", w],
  ["output", w],
  ["button", w],
  ["datalist", w],
  ["textarea", w],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", R],
  ["dt", R],
  ["address", d],
  ["article", d],
  ["aside", d],
  ["blockquote", d],
  ["details", d],
  ["div", d],
  ["dl", d],
  ["fieldset", d],
  ["figcaption", d],
  ["figure", d],
  ["footer", d],
  ["form", d],
  ["header", d],
  ["hr", d],
  ["main", d],
  ["nav", d],
  ["ol", d],
  ["pre", d],
  ["section", d],
  ["table", d],
  ["ul", d],
  ["rt", j],
  ["rp", j],
  ["tbody", $],
  ["tfoot", $]
]), qt = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), Z = /* @__PURE__ */ new Set(["math", "svg"]), H = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), Et = /\s|\//;
class kt {
  constructor(t, i = {}) {
    var s, a, r, h, l, u;
    this.options = i, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = t ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = (s = i.lowerCaseTags) !== null && s !== void 0 ? s : this.htmlMode, this.lowerCaseAttributeNames = (a = i.lowerCaseAttributeNames) !== null && a !== void 0 ? a : this.htmlMode, this.recognizeSelfClosing = (r = i.recognizeSelfClosing) !== null && r !== void 0 ? r : !this.htmlMode, this.tokenizer = new ((h = i.Tokenizer) !== null && h !== void 0 ? h : vt)(this.options, this), this.foreignContext = [!this.htmlMode], (u = (l = this.cbs).onparserinit) === null || u === void 0 || u.call(l, this);
  }
  // Tokenizer event handlers
  /** @internal */
  ontext(t, i) {
    var s, a;
    const r = this.getSlice(t, i);
    this.endIndex = i - 1, (a = (s = this.cbs).ontext) === null || a === void 0 || a.call(s, r), this.startIndex = i;
  }
  /** @internal */
  ontextentity(t, i) {
    var s, a;
    this.endIndex = i - 1, (a = (s = this.cbs).ontext) === null || a === void 0 || a.call(s, z(t)), this.startIndex = i;
  }
  /**
   * Checks if the current tag is a void element. Override this if you want
   * to specify your own additional void elements.
   */
  isVoidElement(t) {
    return this.htmlMode && qt.has(t);
  }
  /** @internal */
  onopentagname(t, i) {
    this.endIndex = i;
    let s = this.getSlice(t, i);
    this.lowerCaseTagNames && (s = s.toLowerCase()), this.emitOpenTag(s);
  }
  emitOpenTag(t) {
    var i, s, a, r;
    this.openTagStart = this.startIndex, this.tagname = t;
    const h = this.htmlMode && wt.get(t);
    if (h)
      for (; this.stack.length > 0 && h.has(this.stack[0]); ) {
        const l = this.stack.shift();
        (s = (i = this.cbs).onclosetag) === null || s === void 0 || s.call(i, l, !0);
      }
    this.isVoidElement(t) || (this.stack.unshift(t), this.htmlMode && (Z.has(t) ? this.foreignContext.unshift(!0) : H.has(t) && this.foreignContext.unshift(!1))), (r = (a = this.cbs).onopentagname) === null || r === void 0 || r.call(a, t), this.cbs.onopentag && (this.attribs = {});
  }
  endOpenTag(t) {
    var i, s;
    this.startIndex = this.openTagStart, this.attribs && ((s = (i = this.cbs).onopentag) === null || s === void 0 || s.call(i, this.tagname, this.attribs, t), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }
  /** @internal */
  onopentagend(t) {
    this.endIndex = t, this.endOpenTag(!1), this.startIndex = t + 1;
  }
  /** @internal */
  onclosetag(t, i) {
    var s, a, r, h, l, u, g, f;
    this.endIndex = i;
    let c = this.getSlice(t, i);
    if (this.lowerCaseTagNames && (c = c.toLowerCase()), this.htmlMode && (Z.has(c) || H.has(c)) && this.foreignContext.shift(), this.isVoidElement(c))
      this.htmlMode && c === "br" && ((h = (r = this.cbs).onopentagname) === null || h === void 0 || h.call(r, "br"), (u = (l = this.cbs).onopentag) === null || u === void 0 || u.call(l, "br", {}, !0), (f = (g = this.cbs).onclosetag) === null || f === void 0 || f.call(g, "br", !1));
    else {
      const m = this.stack.indexOf(c);
      if (m !== -1)
        for (let x = 0; x <= m; x++) {
          const p = this.stack.shift();
          (a = (s = this.cbs).onclosetag) === null || a === void 0 || a.call(s, p, x !== m);
        }
      else this.htmlMode && c === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = i + 1;
  }
  /** @internal */
  onselfclosingtag(t) {
    this.endIndex = t, this.recognizeSelfClosing || this.foreignContext[0] ? (this.closeCurrentTag(!1), this.startIndex = t + 1) : this.onopentagend(t);
  }
  closeCurrentTag(t) {
    var i, s;
    const a = this.tagname;
    this.endOpenTag(t), this.stack[0] === a && ((s = (i = this.cbs).onclosetag) === null || s === void 0 || s.call(i, a, !t), this.stack.shift());
  }
  /** @internal */
  onattribname(t, i) {
    this.startIndex = t;
    const s = this.getSlice(t, i);
    this.attribname = this.lowerCaseAttributeNames ? s.toLowerCase() : s;
  }
  /** @internal */
  onattribdata(t, i) {
    this.attribvalue += this.getSlice(t, i);
  }
  /** @internal */
  onattribentity(t) {
    this.attribvalue += z(t);
  }
  /** @internal */
  onattribend(t, i) {
    var s, a;
    this.endIndex = i, (a = (s = this.cbs).onattribute) === null || a === void 0 || a.call(s, this.attribname, this.attribvalue, t === S.Double ? '"' : t === S.Single ? "'" : t === S.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }
  getInstructionName(t) {
    const i = t.search(Et);
    let s = i < 0 ? t : t.substr(0, i);
    return this.lowerCaseTagNames && (s = s.toLowerCase()), s;
  }
  /** @internal */
  ondeclaration(t, i) {
    this.endIndex = i;
    const s = this.getSlice(t, i);
    if (this.cbs.onprocessinginstruction) {
      const a = this.getInstructionName(s);
      this.cbs.onprocessinginstruction(`!${a}`, `!${s}`);
    }
    this.startIndex = i + 1;
  }
  /** @internal */
  onprocessinginstruction(t, i) {
    this.endIndex = i;
    const s = this.getSlice(t, i);
    if (this.cbs.onprocessinginstruction) {
      const a = this.getInstructionName(s);
      this.cbs.onprocessinginstruction(`?${a}`, `?${s}`);
    }
    this.startIndex = i + 1;
  }
  /** @internal */
  oncomment(t, i, s) {
    var a, r, h, l;
    this.endIndex = i, (r = (a = this.cbs).oncomment) === null || r === void 0 || r.call(a, this.getSlice(t, i - s)), (l = (h = this.cbs).oncommentend) === null || l === void 0 || l.call(h), this.startIndex = i + 1;
  }
  /** @internal */
  oncdata(t, i, s) {
    var a, r, h, l, u, g, f, c, m, x;
    this.endIndex = i;
    const p = this.getSlice(t, i - s);
    !this.htmlMode || this.options.recognizeCDATA ? ((r = (a = this.cbs).oncdatastart) === null || r === void 0 || r.call(a), (l = (h = this.cbs).ontext) === null || l === void 0 || l.call(h, p), (g = (u = this.cbs).oncdataend) === null || g === void 0 || g.call(u)) : ((c = (f = this.cbs).oncomment) === null || c === void 0 || c.call(f, `[CDATA[${p}]]`), (x = (m = this.cbs).oncommentend) === null || x === void 0 || x.call(m)), this.startIndex = i + 1;
  }
  /** @internal */
  onend() {
    var t, i;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let s = 0; s < this.stack.length; s++)
        this.cbs.onclosetag(this.stack[s], !0);
    }
    (i = (t = this.cbs).onend) === null || i === void 0 || i.call(t);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var t, i, s, a;
    (i = (t = this.cbs).onreset) === null || i === void 0 || i.call(t), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (a = (s = this.cbs).onparserinit) === null || a === void 0 || a.call(s, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(!this.htmlMode), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   *
   * @param data Document to parse.
   */
  parseComplete(t) {
    this.reset(), this.end(t);
  }
  getSlice(t, i) {
    for (; t - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    let s = this.buffers[0].slice(t - this.bufferOffset, i - this.bufferOffset);
    for (; i - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), s += this.buffers[0].slice(0, i - this.bufferOffset);
    return s;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  write(t) {
    var i, s;
    if (this.ended) {
      (s = (i = this.cbs).onerror) === null || s === void 0 || s.call(i, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(t), this.tokenizer.running && (this.tokenizer.write(t), this.writeIndex++);
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   *
   * @param chunk Optional final chunk to parse.
   */
  end(t) {
    var i, s;
    if (this.ended) {
      (s = (i = this.cbs).onerror) === null || s === void 0 || s.call(i, new Error(".end() after done!"));
      return;
    }
    t && this.write(t), this.ended = !0, this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }
  /**
   * Alias of `write`, for backwards compatibility.
   *
   * @param chunk Chunk to parse.
   * @deprecated
   */
  parseChunk(t) {
    this.write(t);
  }
  /**
   * Alias of `end`, for backwards compatibility.
   *
   * @param chunk Optional final chunk to parse.
   * @deprecated
   */
  done(t) {
    this.end(t);
  }
}
function yt(e, t) {
  const i = new mt(void 0, t);
  return new kt(i, t).end(e), i.root;
}
const Dt = dt((e, t, i, s) => t._useHtmlParser2 ? yt(e, t) : It(e, t, i, s)), Bt = bt(Dt, (e, t) => t._useHtmlParser2 ? ft(e, t) : At(e)), _t = (e) => {
  if (!e)
    return { href: void 0, label: void 0 };
  const i = Bt(e)("a");
  if (!i.length)
    return { href: void 0, label: e };
  if ((i == null ? void 0 : i.length) !== 1)
    return { href: void 0, label: void 0 };
  const s = i.attr("href"), a = i.text();
  return { href: s, label: a };
};
function Ot(e) {
  return e == null ? void 0 : e.reduce((i, s) => {
    var h;
    const a = tt(
      (h = s == null ? void 0 : s.standardEquipments) == null ? void 0 : h.sort((l, u) => l.priority - u.priority),
      "equipmentCategoryRoot"
    );
    s == null || delete s.standardEquipments;
    const r = {
      ...s,
      standardEquipmentPerEquipmentCategory: a
    };
    return i[s == null ? void 0 : s.categoryType] = r, i;
  }, {});
}
const v = (e, t) => {
  const { features: i, name: s = "" } = e.get(t) || {}, a = (i ?? []).filter(({ priority: r }) => !!r).sort((r, h) => Number(r.priority) - Number(h.priority)).reduce(
    (r, { code: h, name: l, featureValues: u }) => {
      var g;
      return [
        ...r,
        {
          code: h,
          name: l,
          value: _t((g = u == null ? void 0 : u[0]) == null ? void 0 : g.value)
        }
      ];
    },
    []
  );
  return {
    name: s,
    classifications: a
  };
};
function Ut({
  productDetails: e
}) {
  const { categories: t, classifications: i, modelYear: s } = e, a = Ot(t), r = J(i, "code"), h = v(
    r,
    N.CONSUMPTION
  ), l = v(
    r,
    N.DIMENSION
  ), u = v(
    r,
    N.ENGINE
  ), g = v(
    r,
    N.WEIGHTS
  ), f = v(
    r,
    N.POWER
  ), c = v(
    r,
    N.EU_TIRE_LABEL
  ), m = v(
    r,
    N.PRODUCTIONDATA
  );
  return {
    consumption: h,
    dimensions: l,
    engine: u,
    equipment: a,
    payloadCapacities: g,
    power: f,
    tireLabels: c,
    productionData: m,
    modelYear: s
  };
}
export {
  Ut as c,
  Pt as g,
  _t as p
};
//# sourceMappingURL=create-product-details-pdf-model-DDWYfSOD.mjs.map
